import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';

const ProductPriceWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
  
  @media screen and (max-width: 800px) {
    flex-direction: row;
    gap: 15px;
    justify-content: flex-start;
  }
`

const ProductPriceNormal = styled('p')`
  margin: 0;
  font-size: 16px;

  @media screen and (max-width: 800px) {
    font-size: 14px;
  }
`;

const ProductPriceDiscount = styled('p')`
  margin: 0;
  font-size: 14px;
  color: red;
`;

const ProductPricePrevious = styled('p')`
  margin: 0;
  font-size: 12px;
  text-decoration: line-through;
  @media screen and (max-width: 800px) {
    font-size: 12px;
  }
`;

export const ProductPriceSummary = ({ price, discount }) => {
  return (
    <>
      {discount ? (
        <>
          <ProductPriceWrapper>
            <ProductPriceDiscount><b>{t('Pris')}:</b> {discount}:-</ProductPriceDiscount>
            <ProductPricePrevious>{price} kr</ProductPricePrevious>
          </ProductPriceWrapper>
        </>
      ) : (
        <ProductPriceNormal><b>{t('Pris')}:</b> {price}:-</ProductPriceNormal>
      )}
    </>
  );
}